import React from 'react'
import { Flex } from '@nic/ui-comps'
import { RequestLookupModal } from './RequestLookupModal'
import { RequestDomainLookupModal } from './RequestDomainLookupModal'
import { RequestQuickSearch } from './RequestQuickSearch'

type RequestLookupVariant = 'desktop' | 'mobile'

interface RequestSearchSectionProps {
  variant?: RequestLookupVariant
  buttonColor?: string
}

export const RequestSearchSection: React.FC<RequestSearchSectionProps> = ({
  variant = 'desktop',
  buttonColor,
}) => {
  const isDesktop = variant === 'desktop'

  return (
    <Flex
      direction={isDesktop ? 'row' : 'column'}
      style={{
        gap: isDesktop ? '12px' : '16px',
        alignItems: isDesktop ? 'center' : 'stretch',
        width: isDesktop ? 'auto' : '100%',
      }}
    >
      <RequestQuickSearch variant={variant} />
      {!isDesktop && (
        <>
          <RequestLookupModal variant={variant} buttonColor={buttonColor} />
          <RequestDomainLookupModal variant={variant} buttonColor={buttonColor} />
        </>
      )}
    </Flex>
  )
}
